// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3b29b474","455":"55aff42e","488":"bae0ba9c","977":"928a7241"}[chunkId] + ".chunk.js";
};